import React, { useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../Card';
import { Building2, ExternalLink, Send } from 'lucide-react';
import { Table, TableHeader, TableBody, TableRow, TableHead, TableCell } from '../Table';
import { Badge } from '../Badge';
import { Button } from '../Button';
import { toast } from 'sonner';
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '../Dialog';
import { Label } from '../Label';
import { Textarea } from '../Textarea';
const ministries = [{
  id: 1,
  name: 'KEMENTERIAN PERTANIAN',
  issue: 'Harga beras melambung & kelangkaan pupuk',
  status: 'PROSES',
  pic: 'Dirjen Tanaman Pangan',
  deadline: '2 Jam',
  score: 65
}, {
  id: 2,
  name: 'KEMENSOS',
  issue: 'Hoaks bansos pangan',
  status: 'BELUM',
  pic: 'Biro Humas',
  deadline: '8 Jam',
  score: 45
}, {
  id: 3,
  name: 'KOMDIGI',
  issue: 'Deepfake audio Presiden & operasi tagar',
  status: 'PROSES',
  pic: 'Ditjen Aptika',
  deadline: '4 Jam',
  score: 82
}, {
  id: 4,
  name: 'KEMENDAG',
  issue: 'Stabilitas harga bahan pokok',
  status: 'BELUM',
  pic: 'Dirjen PDN',
  deadline: '12 Jam',
  score: 42
}, {
  id: 5,
  name: 'KEPOLISIAN RI',
  issue: 'Ancaman keamanan kunjungan Papua',
  status: 'SELESAI',
  pic: 'Bareskrim Siber',
  deadline: '-',
  score: 95
}, {
  id: 6,
  name: 'KEMENSETNEG',
  issue: 'Klarifikasi agenda IKN tahap 2',
  status: 'PROSES',
  pic: 'Deputi Protokol',
  deadline: '6 Jam',
  score: 78
}];
export function MinistryTable() {
  const [escalateDialog, setEscalateDialog] = useState<{
    open: boolean;
    ministry: any;
  }>({
    open: false,
    ministry: null
  });
  const handleEscalateSubmit = () => {
    toast.success('Teguran berhasil dikirim', {
      description: `Notifikasi eskalasi telah dikirim ke PIC ${escalateDialog.ministry?.name}.`
    });
    setEscalateDialog({
      open: false,
      ministry: null
    });
  };
  return <>
      <Card className="bg-card border-border/50" data-id="element-632">
        <CardHeader className="pb-2 pt-4 px-4 border-b border-border/50" data-id="element-633">
          <CardTitle className="font-mono text-xs uppercase tracking-wider text-muted-foreground flex items-center gap-2" data-id="element-634">
            <Building2 className="size-4" data-id="element-635" />
            Ministry Responsibility Mapping & Tasking
          </CardTitle>
        </CardHeader>
        <CardContent className="p-0" data-id="element-636">
          <div className="overflow-x-auto" data-id="element-637">
            <Table data-id="element-638">
              <TableHeader className="bg-muted/20" data-id="element-639">
                <TableRow className="hover:bg-transparent border-border/50" data-id="element-640">
                  <TableHead className="font-mono text-[9px] h-8 w-[200px]" data-id="element-641">
                    KEMENTERIAN / LEMBAGA
                  </TableHead>
                  <TableHead className="font-mono text-[9px] h-8" data-id="element-642">
                    ISU YANG DITUGASKAN
                  </TableHead>
                  <TableHead className="font-mono text-[9px] h-8" data-id="element-643">
                    STATUS
                  </TableHead>
                  <TableHead className="font-mono text-[9px] h-8" data-id="element-644">
                    PIC
                  </TableHead>
                  <TableHead className="font-mono text-[9px] h-8" data-id="element-645">
                    DEADLINE
                  </TableHead>
                  <TableHead className="font-mono text-[9px] h-8 w-[150px]" data-id="element-646">
                    RESPONSE QUALITY
                  </TableHead>
                  <TableHead className="font-mono text-[9px] h-8 w-[100px] text-right" data-id="element-647">
                    AKSI
                  </TableHead>
                </TableRow>
              </TableHeader>
              <TableBody data-id="element-648">
                {ministries.map(min => <TableRow key={min.id} className="border-border/30 hover:bg-muted/10" data-id="element-649">
                    <TableCell className="py-2 text-xs font-bold" data-id="element-650">
                      {min.name}
                    </TableCell>
                    <TableCell className="py-2 text-xs text-muted-foreground" data-id="element-651">
                      {min.issue}
                    </TableCell>
                    <TableCell className="py-2" data-id="element-652">
                      <Badge variant="outline" className={`font-mono text-[8px] px-1.5 py-0 h-5 border-none ${min.status === 'SELESAI' ? 'bg-emerald-500/10 text-emerald-500' : min.status === 'PROSES' ? 'bg-amber-500/10 text-amber-500' : 'bg-red-500/10 text-red-500'}`} data-id="element-653">
                        {min.status}
                      </Badge>
                    </TableCell>
                    <TableCell className="py-2 text-[10px] font-mono text-muted-foreground" data-id="element-654">
                      {min.pic}
                    </TableCell>
                    <TableCell className="py-2 text-[10px] font-mono text-amber-500" data-id="element-655">
                      {min.deadline}
                    </TableCell>
                    <TableCell className="py-2" data-id="element-656">
                      <div className="flex items-center gap-2" data-id="element-657">
                        <div className="flex-1 h-1.5 bg-muted rounded-full overflow-hidden" data-id="element-658">
                          <div className={`h-full ${min.score >= 80 ? 'bg-emerald-500' : min.score >= 60 ? 'bg-amber-500' : 'bg-red-500'}`} style={{
                        width: `${min.score}%`
                      }} data-id="element-659" />
                        </div>
                        <span className="font-mono text-[9px] w-6 text-right" data-id="element-660">
                          {min.score}
                        </span>
                      </div>
                    </TableCell>
                    <TableCell className="py-2 text-right" data-id="element-661">
                      <Button variant="outline" size="xs" className="h-6 text-[9px] font-mono bg-background/50 border-border/50 hover:bg-background" onClick={() => setEscalateDialog({
                    open: true,
                    ministry: min
                  })} data-id="element-662">
                        Eskalasi <ExternalLink className="size-3 ml-1" data-id="element-663" />
                      </Button>
                    </TableCell>
                  </TableRow>)}
              </TableBody>
            </Table>
          </div>
        </CardContent>
      </Card>

      <Dialog open={escalateDialog.open} onOpenChange={open => !open && setEscalateDialog({
      open: false,
      ministry: null
    })} data-id="element-664">
        <DialogContent className="sm:max-w-[425px] border-border/50 bg-background/95 backdrop-blur" data-id="element-665">
          <DialogHeader data-id="element-666">
            <DialogTitle className="font-mono text-sm uppercase tracking-wider text-amber-500 flex items-center gap-2" data-id="element-667">
              <Building2 className="size-4" data-id="element-668" />
              Eskalasi K/L
            </DialogTitle>
            <DialogDescription className="text-xs" data-id="element-669">
              Kirim teguran atau instruksi percepatan ke PIC Kementerian/Lembaga
              terkait.
            </DialogDescription>
          </DialogHeader>

          {escalateDialog.ministry && <div className="grid gap-4 py-4" data-id="element-670">
              <div className="rounded-md border border-border/50 bg-muted/20 p-3" data-id="element-671">
                <div className="flex justify-between items-start mb-2" data-id="element-672">
                  <h4 className="text-xs font-bold text-foreground" data-id="element-673">
                    {escalateDialog.ministry.name}
                  </h4>
                  <Badge variant="outline" className="font-mono text-[8px] h-4 border-none bg-muted text-muted-foreground" data-id="element-674">
                    Skor: {escalateDialog.ministry.score}
                  </Badge>
                </div>
                <div className="grid grid-cols-2 gap-2 text-[10px]" data-id="element-675">
                  <div data-id="element-676">
                    <span className="text-muted-foreground block" data-id="element-677">Isu:</span>
                    <span className="font-medium" data-id="element-678">
                      {escalateDialog.ministry.issue}
                    </span>
                  </div>
                  <div data-id="element-679">
                    <span className="text-muted-foreground block" data-id="element-680">PIC:</span>
                    <span className="font-medium" data-id="element-681">
                      {escalateDialog.ministry.pic}
                    </span>
                  </div>
                </div>
              </div>

              <div className="grid gap-2" data-id="element-682">
                <Label htmlFor="instruction" className="text-xs" data-id="element-683">
                  Instruksi Percepatan
                </Label>
                <Textarea id="instruction" placeholder="Masukkan instruksi spesifik untuk PIC..." className="text-xs bg-muted/30 border-border/50 min-h-[80px]" defaultValue={`Mohon segera tindak lanjuti isu "${escalateDialog.ministry.issue}". Status saat ini terpantau ${escalateDialog.ministry.status} dengan deadline ${escalateDialog.ministry.deadline}.`} data-id="element-684" />
              </div>
            </div>}

          <DialogFooter data-id="element-685">
            <Button variant="outline" size="sm" onClick={() => setEscalateDialog({
            open: false,
            ministry: null
          })} data-id="element-686">
              Batal
            </Button>
            <Button variant="default" size="sm" className="bg-amber-600 hover:bg-amber-700 text-white" onClick={handleEscalateSubmit} data-id="element-687">
              <Send className="size-3 mr-2" data-id="element-688" />
              Kirim Instruksi
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </>;
}